import {
  type ConnectToCrmWidgetValue,
  type ContactCrmFields,
  type CrmObject,
  ObjectTypes,
} from '@playbooks/action-cards-utils/src'

function mapConnecterWidgetValue(data: CrmObject[]) {
  return (
    data.map<ConnectToCrmWidgetValue>(obj => ({
      name: obj.objectType === ObjectTypes.Contact ? getContactFullName(obj.crmFields) : obj.crmFields.Name,
      url: obj.url,
      type: obj.objectType,
      mail: (obj.crmFields as ContactCrmFields)?.Email,
    })) || []
  )
}

export function getContactFullName(crmFields: ContactCrmFields): string {
  return `${crmFields.FirstName || ''} ${crmFields.LastName || ''}`.trim()
}

export default mapConnecterWidgetValue
